export default __webpack_public_path__ + "static/media/Nunito-SemiBold.77c1e330.ttf";